import { Base } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

/**
 * HeaderBanner component
 *
 * Slider automatique (autoplay) de messages courts affichés en haut du site,
 * texte centré, avec navigation prev/next.
 */
export default class HeaderBanner extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'HeaderBanner',
    refs: ['slider', 'prev', 'next'],
    options: {
      delay: {
        type: Number,
        default: 2500,
      },
    },
  };

  /**
   * Init Swiper on mount.
   */
  mounted() {
    this.slider = new Swiper(this.$refs.slider, {
      modules: [Navigation, Autoplay],
      slidesPerView: 1,
      loop: true,
      allowTouchMove: false,
      autoplay: {
        delay: this.$options.delay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: this.$refs.next,
        prevEl: this.$refs.prev,
      },
    });
  }

  /**
   * Destroy Swiper on unmount.
   */
  destroyed() {
    this.slider?.destroy();
  }
}
